import { Component, Input, OnInit, HostBinding } from '@angular/core';

@Component({
	selector: 'bb-chip',
	templateUrl: './bb-chip.component.html',
	styleUrls: ['./bb-chip.component.scss']
})
export class BbChipComponent implements OnInit {
	@HostBinding('class.active') get isActive() {
		return this.active;
	}
	@Input() active: boolean;

	constructor() { }

	ngOnInit(): void {
	}

}
